import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Dropdown,
} from "reactstrap";
import {
  CaseNotificationsEnum,
  CasePrePostEnum,
  ICaseTaskModel,
} from "../../../models/Cases/CaseDetailsModel";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../../utils/Utils";
import { toast } from "react-toastify";
import PDFIcon from "../../../images/pdf-icon-main.svg";
import Service from "../../../services";
import ReactFileViewer from '../../../commonfields/ReactFileViewer';
import { catchErrorGeneric, fileFormatSupported } from "../../../utils/GeneralUtils";

interface ITaskDetailsProps {
  task: ICaseTaskModel | null;
}

const TaskDetails = (props: ITaskDetailsProps) => {
  const service = new Service();
  const { task } = props;
  const [predecessorOpen, setPredecessorOpen] = useState(false);
  const [successorOpen, setSuccessorOpen] = useState(false);
  const [fileViewerToShow, setFileViewerToShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState<any>();

  const togglePredecessorOpen = () => setPredecessorOpen((prev) => !prev);

  const toggleSuccessorOpen = () => setSuccessorOpen((prev) => !prev);

  const predecessors = task?.casePrePostTaskDetailsList?.filter(
    (each) => each?.type === CasePrePostEnum.PREDECESSOR
  );

  const successors = task?.casePrePostTaskDetailsList?.filter(
    (each) => each?.type === CasePrePostEnum.SUCCESSOR
  );

  const dueNotifications = task?.caseNotifications?.filter(
    (each) => each?.type === CaseNotificationsEnum.DUE
  );

  const completionNotifications = task?.caseNotifications?.filter(
    (each) => each?.type === CaseNotificationsEnum.COMPLETION
  );

  const fileViewerHandler = (documentPath: string | null) => {
    setLoader(true);
    setFileViewerToShow(true);
    if (documentPath) {
      service
        .getDocuments(documentPath)
        .then((res) => {
          if (fileFormatSupported(res?.data?.fileType)) {
            setFile({
              fileName: res.data.fileName,
              fileType: res.data.fileType,
              uri: `${res.data.fileContent}`,
            });
          }
          else {
            toast.error("FileView is not supported");
          }
          setLoader(false);
        })
        .catch((err) => {
          catchError(err, true);
          setLoader(false);
        });
    } else {
      setLoader(false);
      // toast.error("Something went wrong")
      catchErrorGeneric("Something went wrong");
    }
  };

  const cancelFileViewHandler = () => {
    setFileViewerToShow(false);
    setFile(null);
  };

  return (
    <div className="taskDetailsContainer">
      <div className="taskDetailsMainContainer">
        <div className="detailsBox description">
          <div className="detailsTitle">Description</div>
          <div className="detailsValue">{task?.description || "--"}</div>
        </div>

        <div className="detailsBox taskNotes">
          <div className="detailsTitle">Task Notes</div>
          <div className="detailsValue">
            {task?.taskTodo?.todoNotes || "--"}
          </div>
        </div>

        <div className={"detailsBox documents"}>
          <div className="detailsTitle">Documents</div>
          {task?.taskTodo?.manualTodoDocList &&
            task?.taskTodo?.manualTodoDocList?.length > 0 ? (
            task?.taskTodo?.manualTodoDocList?.map((each) => (
              <div
                key={each?.documentId}
                className="detailsValue under-line"
                onClick={() => fileViewerHandler(each?.documentPath)}
              >
                <img src={PDFIcon} alt="PDFIcon" />
                <span className="docName">{each?.documentName || "--"}</span>
              </div>
            ))
          ) : (
            <div className="detailsValue">No Documents Available</div>
          )}
        </div>

        <div className="bottomContainer">
          <div className="predecessorBox">
            <Dropdown
              className="predecessorDropdown"
              direction="up"
              isOpen={predecessorOpen}
              toggle={togglePredecessorOpen}
            >
              <DropdownToggle caret>
                <div className="count">{predecessors?.length || 0}</div>
                <div className="predecessors">
                  <div className="title">Predecessors:</div>
                </div>
              </DropdownToggle>
              {predecessors && predecessors?.length > 0 && (
                <DropdownMenu>
                  {predecessors?.map((each) => (
                    <DropdownItem key={each?.taskId}>
                      {each?.title || "--"}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              )}
            </Dropdown>
          </div>
          <div className="successorBox">
            <Dropdown
              className="successorDropdown"
              direction="up"
              isOpen={successorOpen}
              toggle={toggleSuccessorOpen}
            >
              <DropdownToggle caret>
                <div className="count">{successors?.length || 0}</div>
                <div className="successors">
                  <div className="title">Successor:</div>
                </div>
              </DropdownToggle>
              {successors && successors?.length > 0 && (
                <DropdownMenu>
                  {successors?.map((each) => (
                    <DropdownItem key={each?.taskId}>
                      {each?.title || "--"}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              )}
            </Dropdown>
          </div>
        </div>
      </div>

      {/* Right container - notify users list */}
      <div className="taskNotificationContainer">
        <div className="notificationsBox">
          <div className="notificationTitle">Due Date Notification</div>
          <div className="notificationItemsBox">
            {dueNotifications?.map((each) => (
              <div
                key={each?.caseNotificationId}
                className="notificationItemsBox"
              >
                {each?.userName || "--"}
              </div>
            ))}
          </div>
        </div>

        <div className="notificationsBox">
          <div className="notificationTitle">Completion Notification</div>
          <div className="notificationItemsBox">
            {completionNotifications?.map((each) => (
              <div
                key={each?.caseNotificationId}
                className="notificationItemsBox"
              >
                {each?.userName || "--"}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="fileViewerModalContainer caseDocuments">
        <Modal
          className=" mw-100 w-50 fileViewerModalWrapper"
          isOpen={fileViewerToShow}
          fade={false}
        // toggle={fileViewerHandler}
        >
          <ModalHeader toggle={cancelFileViewHandler}>
            <Row className="customHeader modal-title">
              <Col>
                <div className="fileHeader">{file?.fileName} </div>
              </Col>
            </Row>
            <Row></Row>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {file ? (
                // <FileViewer
                //   fileType={file?.fileType}
                //   filePath={`data:application/${file?.fileType};base64,${file?.image}`}
                // />
                <ReactFileViewer
                  fileDocument={file}
                />

              ) : (
                ""
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default TaskDetails;
